export default {
  txt: ["bar_no"],
  backgrounds: ["geometry_1","geometry_2","geometry_3","geometry_4","geometry_5","geometry_6","geometry_7","geometry_8"],
  letters: ["a_x","a1_big","a1","a2_big","a2","a3_big","a3","a4_big","a4","b_x","b1_big","b1","b2_big","b2","b3_big","b3","b4_big","b4","c_x","c1_big","c1","c2_big","c2","c3_big","c3","c4_big","c4","d_x","d1_big","d1","d2_big","d2","d3_big","d3","d4_big","d4","e_x","e1_big","e1","e2_big","e2","e3_big","e3","e4_big","e4","f_x","f1_big","f1","f2_big","f2","f3_big","f3","f4_big","f4","g_x","g1_big","g1","g2_big","g2","g3_big","g3","g4_big","g4","h_x","h1_big","h1","h2_big","h2","h3_big","h3","h4_big","h4"],
  pauses: ["star"],
  spaces: ["space_4","space_5","space_6","space_7","space_8"],
  spaces2: ["space_1","space_2","space_3"],
  various: ["dotts_1","dotts_2","dotts_3","dotts_4","triangles_1","triangles_2","triangles_3","triangles_4"],
  various2: ["chord_1","chord_2","chord_3","chord_4","stripes_1","stripes_2","stripes_3","stripes_4"],
  mouse: ["circle"]
}

// export default (id) => {
//   let groupName
//   for (var prop in map) {
//     if (Object.prototype.hasOwnProperty.call(map, prop)) {
//       map[prop].forEach((str) => {
//         if (str == id) {
//           groupName = prop
//           return groupName
//         }
//       })
//     }
//   }
//   return groupName
// }
